import { ExpectedVolumeColumns } from "./ExpectedVolumeTableConfig";

export const noLabelColumnOrder: Array<ExpectedVolumeColumns> = [
  "customerName",
  "totalVolume",
  "expectedVolume",
];

export const accompaniedColumnOrder: Array<ExpectedVolumeColumns> = [
  "accompanied12MonthVolPeak",
  "accompaniedExpectedVolPeak",
  "accompanied12MonthVolShoulder",
  "accompaniedExpectedVolShoulder",
  "accompanied12MonthVolOffPeak",
  "accompaniedExpectedVolOffPeak",
];

export const accompaniedExpectedColumnOrder: Array<ExpectedVolumeColumns> = [
  "accompaniedExpectedVolPeak",
  "accompaniedExpectedVolShoulder",
  "accompaniedExpectedVolOffPeak",
];

export const unaccompaniedColumnOrder: Array<ExpectedVolumeColumns> = [
  "unaccompanied12MonthVolPeak",
  "unaccompaniedExpectedVolPeak",
  "unaccompanied12MonthVolShoulder",
  "unaccompaniedExpectedVolShoulder",
  "unaccompanied12MonthVolOffPeak",
  "unaccompaniedExpectedVolOffPeak",
];

export const unaccompaniedExpectedColumnOrder: Array<ExpectedVolumeColumns> = [
  "unaccompaniedExpectedVolPeak",
  "unaccompaniedExpectedVolShoulder",
  "unaccompaniedExpectedVolOffPeak",
];
